import React, {useEffect, useState} from 'react';
import {GET_AGENT_LISt_URL} from '../../api';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import {Link} from "react-router-dom";
import cogoToast from "cogo-toast";
import {editAgentUser, addAgentUser, deleteAgent} from "../../request/apps";
import {capitalize} from "../../utils/capitalize";
import {useSelector} from "react-redux";
import errorHandler from "../../utils/errorHandler";

const Agent = () => {

    document.title = "Agent";

    const id = useSelector((state) => state.auth.user.user.sub);
    const [stateReady, setStateReady] = useState(false);
    const [editForm, setEditForm] = useState(false);

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {

        var table = $('#admin').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting agent list</p>'
            },
            "searching": true,
            "lengthMenu": [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_AGENT_LISt_URL, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success : function(res) {
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: res.data
                        });
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.name
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.email
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return capitalize(data.phone)
                    },
                    "targets": 2
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_user"><i class="fa fa-pencil"></i> Edit</a> <a href="#" class="nav-link delete_user"><i class="fa fa-trash-alt"></i> Delete</a></nav>`
                    },
                    "targets": 3
                }
            ]
        });

        $('#admin').on('click', '.delete_user', function() {
            let extract_td = table.row($(this).closest('tr')).data();

            const error = {
                position: "top-right",
                hideAfter: 5
            };

            if(extract_td.raw._id === id) {
                cogoToast.error('Sorry, this logged account cannot be deleted.', error);
                return false;
            }

            const options = {
                position: "top-right",
                hideAfter: 0
            };

            let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

            deleteAgent(extract_td.raw._id).then((result) => {
                hide();
                const _options = {
                    position: "top-right"
                };

                if(result.error === false) {
                    $('#admin').DataTable().ajax.reload(null, false);
                    cogoToast.success(result.data, _options);
                } else {
                    cogoToast.error(result.data, _options);
                }
            });

            return false;
        });

        $('#admin').on('click', '.edit_user', function() {
            let extract_td = table.row($(this).closest('tr')).data();

            setEditForm(true);

            $("#name").prop('required', true);
            $("#email").prop('required', true);
            $("#phone").prop('required', true);

            $('#new_user').parsley();

            $("#new_user").on('submit', function(e){
                e.preventDefault();
            });

            $("#name").val(extract_td.raw.name);
            $("#email").val(extract_td.raw.email);
            $("#phone").val(extract_td.raw.phone);

            $("#modalAddUser").modal("show");

            return false;
        });
    }, []);

    const handleSubmit = () => {

        if(!$('#new_user').parsley().validate()) {
            return false;
        }

        setStateReady(true);

        const options = {
            position: "top-right",
            hideAfter: 0
        };

        let {hide} = cogoToast.loading('Please wait... contacting server.', options);

        let data = {
            name: $('#name').val(),
            email: $('#email').val(),
            phone: $('#phone').val()
        };

        if(editForm === true) {
            editAgentUser(data).then((result) => {
                hide();
                const _options = {
                    position: "top-right"
                };

                setStateReady(false);

                if(result.error !== true) {
                    handleResetForm();
                    $("#modalAddUser").modal("hide");
                    $(".modal-backdrop").remove();
                    $('#admin').DataTable().ajax.reload();
                    return cogoToast.success(result.data, _options);
                }

                errorHandler(result.data, 'top-right');
            });

            return false;
        }

        addAgentUser(data).then((result) => {
            hide();
            const _options = {
                position: "top-right"
            };

            setStateReady(false);

            if(result.error !== true) {
                handleResetForm();
                $("#modalAddUser").modal("hide");
                $(".modal-backdrop").remove();
                $('#admin').DataTable().ajax.reload();
                return cogoToast.success(result.data, _options);
            }

            errorHandler(result.data, 'top-right');
        });

    };

    const handleResetForm = () => {
        $('#name').val("");
        $('#email').val("");
        $('#designation').val("");
        $('#password').val("");
        $('#b1a').prop({checked: false});
        $('#b2a').prop({checked: false});
        $('#b3a').prop({checked: false});
        $('#new_user').parsley().destroy();
    };

    const handleShowModal = () => {

        setEditForm(false);

        $('#new_user').parsley();

        $("#name").prop('disabled', false);
        $("#email").prop('disabled', false);
        $("#password").prop('required', true);

        $("#new_user").on('submit', function(e){
            e.preventDefault();
        });

        $("#modalAddUser").modal("show");
    };

    const reloadTable = () => {
        $('#admin').DataTable().ajax.reload();
    };

    let renderButton = () => {
        if(stateReady === true) {
            return(
                <button disabled className="btn btn-brand-02 btn-block">
                    <span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>
                    Please Wait</button>
            )
        } else {
            return editForm ? <button className="btn btn-brand-02 btn-block">Update Agent</button> : <button className="btn btn-brand-02 btn-block">Create Agent</button>
        }
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Agent</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Agent</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-user-plus"></i> Add New</button>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Agent List</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable.bind()} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                    {/*<a href="" className="link-03 lh-0 mg-l-10"><i className="icon ion-md-more"></i></a>*/}
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="admin" className="table">
                                    <thead>
                                    <tr>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Email</th>
                                        <th className="wd-20p">Phone</th>
                                        <th className="wd-20p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="modalAddUser" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                            <div className="modal-content">
                                <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </a>
                                    <div className="media-body"><a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={handleResetForm.bind()} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit User" : "Create User"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} user to have access to the console</p></div>
                                </div>
                                <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                    <form id="new_user" className="parsley-style-1" data-parsley-validate="true" noValidate onSubmit={handleSubmit.bind()}>
                                        <div id="nameWrapper" className="form-group parsley-input">
                                            <label>Full Name<span className="tx-danger">*</span></label>
                                            <input id="name" type="text" className="form-control"
                                                   placeholder="Enter full name"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#nameWrapper" required/>
                                        </div>

                                        <div id="emailWrapper" className="form-group parsley-input">
                                            <label>Email Address<span className="tx-danger">*</span></label>
                                            <input id="email" type="email" className="form-control"
                                                   placeholder="Enter valid email address"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#emailWrapper" required/>
                                        </div>

                                        <div id="phoneWrapper" className="form-group parsley-input">
                                            <label>Phone<span className="tx-danger">*</span></label>
                                            <input id="phone" type="tel" className="form-control"
                                                   placeholder="Enter phone number"
                                                   autoComplete="none"
                                                   data-parsley-class-handler="#phoneWrapper"/>
                                        </div>
                                        {renderButton()}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Agent;
